import axiosPrivate from "@services/axiosPrivate";

export const getSupportTicket = (data) => {
    return axiosPrivate.get('/getSupportTicket', { params: data });
  };
  